export default __webpack_public_path__ + "static/media/as-val.eddbd559.svg";